import DownloadMultipleSettingsForm from './DownloadMultipleSettingsForm'

export default DownloadMultipleSettingsForm
